import React, {Component} from "react";
import TopBar from "../../component/projectDetail/TopBar";
import Banner from "../../component/projectDetail/Banner";
import RightPanel from "../../component/projectDetail/RightPanel";
import axios from "axios";
import * as _ from "lodash";
import {setProjectDetails} from "../../../reducer/showAllReducer";
import {connect} from "react-redux";
import { getName } from "../../../commons/CommonFunctions";
import {authService} from "../../../auth";
import alertPopUp from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import StudioListData from "../../component/Studio/StudioListData";
import "react-datepicker/dist/react-datepicker.css";
import { actionProjectDonationSwal } from "../../../Donation/DonationCommonFunction";
import { withRouter } from "react-router-dom";
import OrganizationAdmin from "../../../commons/OrganizationAdmin";
import { convertToFirstCapital } from "../../../utils/StringUtility";

const ErorrMsgPopUp = withReactContent(alertPopUp);
class ProjectSettingsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData :  authService.getUserDetailsFromLocalStorage(),
            participants: [],          
            project: props.project,          
            projectDetail: {},
            privateProject:{},
            showStudioSection: true,
            userId: this.props?.location?.state?.userId ? this.props?.location?.state?.userId : authService.getUserDetailsFromLocalStorage().userId
        }
    }

    componentWillUnmount() {
        window.$('.modal-backdrop').remove();
        ErorrMsgPopUp.clickConfirm();
    }

    componentDidMount() {
        this.getSubscriptionConfig();
        if(this.props.projectDetail && this.props.projectDetail.privateProjectPermission){
            this.getPrivateProjectData();
        }
    }

    getSubscriptionConfig = () => {
        let postBody = {
            "userId": this.props.projectDetail?.partyType === "CIRCLE" ? this.props.projectDetail?.superAdminId : this.props.userId,
        };
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_userServiceURL}/user/subscription/global/config` ,
            data: postBody,
            headers: {'Content-Type': 'application/json'},

            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res.status === '200 OK') {
                this.setState({'subscriptionConfig': res.body})
            }

        }).catch((err) => {
            if (err && err.response) {
                this.setState({
                    error: {message: err.response.data.message, err: err.response}
                })
            }
            this.setState({
                isLoaded: true
            });
        });
    };

    getPrivateProjectData = () => {
        axios({
            method: "get",
            url: process.env.REACT_APP_userServiceURL + '/backend/managecirclepermission/get-private-project?projectId='+this.props.projectDetail.projectId+"&userId="+this.state.userId,
            headers: {"Content-Type": "application/json"},
            withCredentials: true,
        })
            .then((response) => {
                if (response && response.data && response.data.message === "Success!") {
                   this.setState({'privateProject':response.data.body});
                }
            })
            .catch((err) => {
                this.setState({
                    loading: false
                })
                console.log(err);
            });
    }
    
    getOptimizedImage(project) {
        if (project.resizedImages && project.resizedImages['300x300'] != null) {
            return project.resizedImages['300x300'];
        }
        return project.coverImage;
    }

    updateProjectPermission=(event,type)=>{

        if(this.props.projectDetail?.managePermissionAllowed){
            let project = this.state.project;
            project.project.projectParticipantPermission[type]=event.target.checked;
            this.setState({project:project});

            let postData={
                projectId: project.project.id,
                projectParticipantPermission: project.project.projectParticipantPermission

            }
            axios({
                method:'post',
                url:process.env.REACT_APP_userServiceURL + '/backend/managecirclepermission/update/project/participant/permission',
                headers:{ 'Content-Type': 'application/json' },
                data:postData,
                withCredentials: true
            }).then((response)=>{
                let res = response.data
                if(res && res.status === '202 ACCEPTED'){
                    this.getSubscriptionConfig();

                }
            }).catch((err)=>{
                console.log(err)

            })
        }else{
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then((result) => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <><p>Manage Permissions in a project is a premium feature. Please upgrade your WeNaturalists Pro subscription.</p><a class="styleBtn" href={'/wenaturalists-pro'}>Upgrade your Membership</a>{/* <div className='registerFreetrial'><a href='/wenaturalists-pro'>Register for a Free Trial</a></div> */}</>,
                })
            })
        }

    }

    updatePostProjectPermission=(event,type)=>{
        if(this.props.projectDetail?.postCompletionPermission){
            let project = this.state.project;
            project.project.projectPostCompletion[type === "ALLOW_TO_JOIN_PROJECT" ? "allowToJoinProject" : type === "APPROVAL_REQUIRED" ? "approvalRequired" : "profileVisibility"]=event.target.checked;
            this.setState({project:project});
            let postData={
                userId:this.state.userData.userId,
                projectId: project.project.id,
                postCompletionType: type,
                status: event.target.checked
            }
            axios({
                method:'post',
                url:process.env.REACT_APP_userServiceURL + '/backend/project/update/postProject/completionStatus',
                headers:{ 'Content-Type': 'application/json' },
                data:postData,
                withCredentials: true
            }).then((response)=>{
                let res = response.data
                if(res && res.status === '202 ACCEPTED'){
                
                }
            }).catch((err)=>{
                console.log(err)
            })
        } else{
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then((result) => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <><p>Manage Permissions in a project is a premium feature. Please upgrade your WeNaturalists Pro subscription.</p><a class="styleBtn" href={'/wenaturalists-pro'}>Upgrade your Membership</a>{/* <div className='registerFreetrial'><a href='/wenaturalists-pro'>Register for a Free Trial</a></div> */}</>,
                })
            })
        }
    }

    changeStatus = (event,data,visibility, projectDetail) =>{
        let permission = this.state.privateProject;
        if(permission && projectDetail.subscribed) {
         if(visibility == "PRIVATE" && !_.isEmpty(projectDetail.donation)) {
            const privateConfirm = async () => {
                const swalval = await ErorrMsgPopUp.fire(actionProjectDonationSwal("PRIVATE"));
                if (swalval && swalval.value === true) {
                    permission.visibility = visibility;
                    this.setState({permission});
                    this.updatePrivateProjectPermission(permission);
                }
            };
            privateConfirm();
            return;
         }
         if((permission.visibility === 'EVERYONE' || permission.visibility === 'OUTSIDE') && visibility !== 'EVERYONE' && visibility !== 'OUTSIDE' && this.state.subscriptionConfig?.projectConfig?.privateProjectCountLimitExceeded){
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then((result) => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <><p>You have created the maximum private projects allowed in your subscription plan. Please upgrade your subscription plan to proceed.</p><a class="styleBtn" onClick={(e)=>this.props.history.push({
                        pathname: '/wenaturalists-pro',
                        state: {
                            userId: this.state.userId
                        }
                    })} href='/wenaturalists-pro'>Upgrade your Membership</a>{/* <div className='registerFreetrial'><a href='/wenaturalists-pro'>Register for a Free Trial</a></div> */}</>,
                })
            })
            return;
        }

            permission.visibility = visibility;

            this.setState({permission});
            this.updatePrivateProjectPermission(permission);
        } else if(visibility === 'EVERYONE' && visibility === 'OUTSIDE') {
            permission.visibility = visibility;

            this.setState({permission});
            this.updatePrivateProjectPermission(permission);
        }else {
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then((result) => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <><p>Please upgrade your subscription plan to make your project private.</p><a class="styleBtn" href={'javascript:void(0)'} onClick={(e) => this.redirectToSubscriptionPage()}>Upgrade your Membership</a>{/* <div className='registerFreetrial'><a href='/wenaturalists-pro'>Register for a Free Trial</a></div> */}</>,
                })
            })
        }
    }

    redirectToSubscriptionPage = () => {
        this.props.history.push({
            pathname: '/wenaturalists-pro',
            state: {
                userId: this.state.userId
            }
        })
    }

    updatePrivateProjectPermission=(permission)=>{
        let postData={
            projectId: permission.projectId,
            config: permission.visibility,
            partyType:permission.type,
            userId:this.state.userId

        }
        axios({
            method:'post',
            url:process.env.REACT_APP_userServiceURL + '/managecirclepermission/update/private-project',
            headers:{ 'Content-Type': 'application/json' },
            data:postData,
            withCredentials: true
        }).then((response)=>{
            let res = response.data
            if(res && res.status === '202 ACCEPTED'){


            }
        }).catch((err)=>{
            console.log(err)

        })
    }

    checkShowStudioSection = () => {
        this.setState({
            showStudioSection: false
        })
    }

    render() {
        const { displayRange } = this.state;
        return (
            <div className="col-md-9">                
                <div className="projectinn nothidden projdetailscont pdSettingPerms">
                    <Banner {...this.props} />
                    {this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false &&
                    <TopBar {...this.props} />
                    }

                    {this.props.userId && <OrganizationAdmin userId={this.props.userId} />}

                    <div className="projdetlswrap">
                        <div className="row">
                            <div className="col-lg-9">
                                {this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false && this.props.projectDetail.applicationsTabVisible && this.props.projectDetail.participantTabVisible &&

                                <div className="projgeneralsec pdapplicationother">
                                    {this.props.projectDetail && this.props.projectDetail.managePermission &&
                                        <div className="settMngPermsRow">                                        
                                            {/* <div className="mngInvPrjctsUsersBx">
                                                <figure className="users group">
                                                    <img
                                                        src={this.props.projectDetail && this.props.projectDetail.project && this.props.projectDetail.project.coverImage ? getCDNUrl(this.getOptimizedImage(this.props.projectDetail.project)) : "https://cdn.dscovr.com/images/project-default.webp"}
                                                        alt=""/>
                                                </figure>
                                                <div>
                                                    <h5>{this.props.projectDetail && this.props.projectDetail.project && this.props.projectDetail.project.title}</h5>
                                                    <p>{this.props.projectDetail && this.props.projectDetail.project && this.props.projectDetail.project.type}</p>
                                                </div>
                                            </div> */}

                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <h4>Manage Participant Permissions</h4>
                                                    <p className={'note'}>You can manage the permissions you
                                                        prefer to grant to the participants
                                                        for {this.props.projectDetail && this.props.projectDetail.project && this.props.projectDetail.project.type} {this.props.projectDetail && this.props.projectDetail.project && this.props.projectDetail.project.title} community</p>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="settMngPermsCheckBox">
                                                        {this.props.projectDetail?.entityType !== "JOB" &&
                                                            <a tabIndex="0" className="custom-control custom-checkbox">
                                                                <input type="checkbox" className="custom-control-input"
                                                                    id={'m07'}
                                                                    checked={this.state.project && this.state.project.project && this.state.project.project.projectParticipantPermission && this.state.project.project.projectParticipantPermission.post}
                                                                    onClick={(e) => {
                                                                        this.updateProjectPermission(e, 'post');
                                                                    }}/>
                                                                <label className="custom-control-label" htmlFor="m07">Post
                                                                    in Project</label>
                                                            </a>
                                                        }
                                                        {this.props.projectDetail?.entityType !== "FUNDRAISE" && 
                                                            <>
                                                                <a tabIndex="0" className="custom-control custom-checkbox">
                                                                    <input type="checkbox" className="custom-control-input"
                                                                        id={'m08'}
                                                                        checked={this.state.project && this.state.project.project && this.state.project.project.projectParticipantPermission && this.state.project.project.projectParticipantPermission.invite}
                                                                        onClick={(e) => {
                                                                            this.updateProjectPermission(e, 'invite');
                                                                        }}/>
                                                                    <label className="custom-control-label" htmlFor="m08">Invite
                                                                        New Participants</label>
                                                                </a>
                                                                <a tabIndex="0" className="custom-control custom-checkbox">
                                                                    <input type="checkbox" className="custom-control-input"
                                                                        id={'m08a'}
                                                                        checked={this.state.project && this.state.project.project && this.state.project.project.projectParticipantPermission && this.state.project.project.projectParticipantPermission.outside}
                                                                        onClick={(e) => {
                                                                            this.updateProjectPermission(e, 'outside');
                                                                        }}/>
                                                                    <label className="custom-control-label" htmlFor="m08a">Invite
                                                                        friends outside WeNaturalists</label>
                                                                </a> 
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {this.props?.projectDetail?.postCompletionPermission &&
                                        <div className="settMngPermsRow">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <h4>Receive Applications</h4>
                                                    <p className={'note'}>You can allow members to join your project. Profile Visibility allows you to choose if the project participant can display this project in their profile {/* {convertToFirstCapital(this.props?.projectDetail?.project?.type)} {this.props?.projectDetail?.project?.title} community */}</p>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="settMngPermsCheckBox">
                                                            {this.props?.projectDetail?.project?.type !== "FUNDRAISE" && 
                                                                <>
                                                                    <a tabIndex="0" className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input"
                                                                            id={'ALLOW_TO_JOIN_PROJECT'}
                                                                            checked={this.state.project?.project?.projectPostCompletion?.allowToJoinProject}
                                                                            onClick={(e) => {
                                                                                this.updatePostProjectPermission(e, 'ALLOW_TO_JOIN_PROJECT');
                                                                            }}/>
                                                                        <label className="custom-control-label" htmlFor="ALLOW_TO_JOIN_PROJECT"> Allow to join project</label>
                                                                    </a>
                                                                    <a tabIndex="0" className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input"
                                                                            id={'APPROVAL_REQUIRED'}
                                                                            checked={this.state.project?.project?.projectPostCompletion?.approvalRequired}
                                                                            onClick={(e) => {
                                                                                this.updatePostProjectPermission(e, 'APPROVAL_REQUIRED');
                                                                            }}/>
                                                                        <label className="custom-control-label" htmlFor="APPROVAL_REQUIRED"> Approval required</label>
                                                                    </a>
                                                                </>
                                                            }
                                                            <a tabIndex="0" className="custom-control custom-checkbox">
                                                                <input type="checkbox" className="custom-control-input"
                                                                    id={'PROFILED_VISIBILITY'}
                                                                    checked={this.state.project?.project?.projectPostCompletion?.profileVisibility}
                                                                    onClick={(e) => {
                                                                        this.updatePostProjectPermission(e, 'PROFILED_VISIBILITY');
                                                                    }}/>
                                                                <label className="custom-control-label" htmlFor="PROFILED_VISIBILITY"> Profile visibility</label>
                                                            </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {this.props.projectDetail && this.props.projectDetail.privateProjectPermission &&
                                    <div className="settMngPermsRow">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <h4>Manage your project status</h4>
                                                <p className={'note'}>Set preferences on who can view and apply to a project. It will be an "invitation only" view and apply, making it a private project</p>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className='privacySettrow'>
                                                    <div className="privacySettdrop">
                                                        <button type="button" className="btn dropdown-toggle" data-toggle="dropdown">
                                                            {/* <i className="iGlobe"/>  */}
                                                            {getName(this.state.privateProject.visibility)}
                                                        </button>
                                                        <div className="dropdown-menu fadeIn animated">
                                                            {this.state.privateProject && this.state.privateProject.showConfigList && this.state.privateProject.showConfigList.map(
                                                                (config, configindex) => (
                                                                    <a key={configindex} className="dropdown-item"
                                                                       onClick={(e) => this.changeStatus(e, this.state.privateProject,config, this.props.projectDetail)}
                                                                       href="javascript:void(0)">{getName(config)}</a>

                                                                ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                            
                                    </div>
                                    }

                                    {this.state.showStudioSection &&
                                        <div className="settMngPermsRow">
                                            <StudioListData projectId={this.props.projectDetail.id} studioPageType={"SETTING"} checkShowStudioSection={this.checkShowStudioSection} userId={this.state.userId} />
                                        </div>
                                    }                                   
                                </div>
                                }
                            </div>


                            <RightPanel {...this.props}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setProjectDetails: (details) => dispatch(setProjectDetails(details)),
    };
};


export default withRouter(connect(null, mapDispatchToProps)(ProjectSettingsContainer));
